import React from "react";
import "./Contact.css";
import {ImLocation2} from 'react-icons/im'
import {MdOutgoingMail} from 'react-icons/md'
const ContactSection = () => {
  return (
    <section className="contact" id="contact">
      <div className="contact-items">
        <div className="contact-title">
        <h3>CONTACT</h3>
        <p>Don't be shy! Hit me up! 👇</p>
        </div>
        <div className="contact-icon">
          <div className="contact-icon-box">
            <span><ImLocation2 style={{fontSize:'1.5rem',color:'#147efb'}} /></span>
            <div className="contact-info">
                <h3>Location</h3>
                <p>Peshawar, Pakistan</p>
            </div>
          </div>
          <div className="contact-icon-box">
            <span><MdOutgoingMail style={{fontSize:'1.5rem',color:'#147efb'}} /></span>
            <div className="contact-info">
                <h3 >Mail</h3>
                <a href="https://mail.google.com/" target="-blank">asaz87464@gmail.com</a>
            </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
